var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.18a.24.24 0 010-.35l9.257-9.274a1.49 1.49 0 000-2.121 1.509 1.509 0 00-2.12 0L12.18 9.699a.251.251 0 01-.36 0L2.562.435A1.51 1.51 0 00.115.92a1.492 1.492 0 00.328 1.635L9.7 11.83a.24.24 0 010 .35L.443 21.444a1.49 1.49 0 000 2.121 1.51 1.51 0 002.12 0l9.257-9.264a.252.252 0 01.278-.057c.03.014.059.033.082.057l9.258 9.264a1.509 1.509 0 002.447-.486 1.492 1.492 0 00-.328-1.635L14.3 12.18z"
  })));
}
export default SvgIconClose24;